import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from '../services/subscriptionService';
import { BUNDLE_CERTIFICATE_PLAN_ID } from '../config/bundleConfig';

/**
 * Precio del bundle, leído del catálogo de suscripciones.
 *
 * Es el precio del plan del certificado: $99.99 en QA, $119.99 en producción,
 * sin que el portal tenga que saberlo ni mantenerlo. El monto que se cobra de
 * verdad lo resuelve el backend leyendo el mismo plan, así que la pantalla y el
 * cobro no pueden discrepar.
 *
 * Devuelve `null` mientras carga o si no se pudo leer, para que la UI no muestre
 * un precio inventado.
 */
export function useBundlePrice() {
  const { data, isLoading } = useQuery({
    queryKey: ['bundle', 'certificate-plan', BUNDLE_CERTIFICATE_PLAN_ID],
    queryFn: () => subscriptionService.getPlanById(BUNDLE_CERTIFICATE_PLAN_ID),
    enabled: BUNDLE_CERTIFICATE_PLAN_ID.length > 0,
    staleTime: 10 * 60 * 1000, // el precio no cambia seguido
  });

  const price = data?.price != null ? Number.parseFloat(String(data.price)) : NaN;

  return {
    price: Number.isFinite(price) && price > 0 ? price : null,
    isLoading,
  };
}
